<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,

        data() {
            return {
                chartData: null,
            }
        },

        props: {
            chartId: {
                type: String,
                'default': 'ActiveUsers'
            },
            height: {
                type: Number,
                'default': 150
            },
            parameter: {
                'default': null
            }
        },
        created() {
            this.fetchData();
        },

        methods: {
            fetchData: function() {
                axios.get(`${Scoop.baseUrl}/api/components/statisticActiveUsersDevelopment`)
                    .then(response => {
                        this.chartData = response.data;
                    });
            }
        },

        watch: {
            parameter: {
                handler: function() {
                    this.fetchData();
                },
                deep: true
            },
            chartData: function (data) {
                if (this._chart === undefined) {
                    this.renderChart(data, {
                        legend: {
                            display: true
                        },
                        ticks: {
                            autoSkip: true
                        }
                    });
                } else {
                    this._chart.data = data;
                    this._chart.update();
                }
            }
        }
    };
</script>

